const BlockList = require('app/components/lists/BlockList')
const List = require('app/components/products/ProductList')

class RelatedProducts extends BlockList {
  static get defaultProps () {
    return {
      title: translate('Du vil måske også kunne lide'),
      subtitle: translate('Relaterede produkter'),
      items: []
    }
  }

  get baseClassName () {
    return 'static-list related-products mobile-slider'
  }

  renderList () {
    return (
      <List items={this.props.items} />
    )
  }
}

module.exports = RelatedProducts
